export const createPayload = async (formData: any) => {
  const documents = [
    {
      documentType: "bank_cancelled_cheque",
      file: formData.bank.bank_cancelled_cheque,
    },
    {
      documentType: "lic_gst_cert",
      file: formData.license.lic_gst_cert,
    },
    {
      documentType: "lic_license_pan",
      file: formData.license.lic_license_pan,
    },
    {
      documentType: "lic_rvb_license",
      file: formData.license.lic_rvb_license,
    },
    {
      documentType: "comp_gst_cert",
      file: formData.company.comp_gst_cert,
    },
    {
      documentType: "comp_pan_card",
      file: formData.company.comp_pan_card,
    },
    {
      documentType: "comp_vat_cert",
      file: formData.company.comp_vat_cert,
    },
  ];

  const documentArray = await Promise.all(
    documents
      .filter((doc) => doc.file instanceof File || doc.file == "")
      .map(async (doc) => {
        if (doc.file == "") {
          return {
            documentType: doc.documentType,
            fileName: "",
            fileType: "",
            fileContent: "",
          };
        }
        return {
          documentType: doc.documentType,
          fileName: doc.file.name,
          fileType: doc.file.type,
          fileContent: doc.file || null,
        };
      })
  );

  const assignedUser = formData.assignedSalesRep?.id
    ? {
        id: formData.assignedSalesRep.id,
        role: formData.assignedSalesRep.role,
      }
    : undefined;

  return {
    address: {
      licenseName: formData.license.licenseName,
      licenseType: formData.license.licenseType,
      exciseRegistrationNumber:
        formData.license.customerExciseRegistrationNumber,
      registeredAddress: formData.company.registeredAddress,
      pinCode: formData.company.pincode,
      status: "ACTIVE",
      customerExciseRegNumber:
        formData.license.customerExciseRegistrationNumber,
      licensePANNumber: formData.license.licensePAN,
      licenseGSTNumber: formData.license.licenseGST,
      licenseAddress: formData.license.licenseAddress,
      gstStateCode: formData.license.gstStateCode,
    },

    bank: {
      bankName: formData.bank.bankName,
      bankBranch: formData.bank.bankBranch,
      accountType: formData.bank.accountType,
      bankAccountNumber: formData.bank.accountNumber,
      ifscCode: formData.bank.ifscCode,
      beneficiaryName: formData.bank.beneficiaryName,
      accountsDeptPOCName: formData.bank.accountsDepartmentPOCName,
      accountsDeptPOCNumber: formData.bank.accountsDepartmentPOCNumber,
    },

    customer: {
      activationEmail: formData.emailActivation,
      outletName: formData.company.outletName,
      companyGSTNumber: formData.company.companyGST,
      companyPANNumber: formData.company.companyPAN,
      companySignatoryName: formData.company.authorizedSignatory,
      vatNumber: formData.company.vatNumber,
      state: formData.company.state,
      pincode: formData.company.pincode,
      emailId: formData.company.emailID,
      gstStateCode: formData.company.gstStateCode,
      advancePaymentMandatory: String(formData.advancePaymentMandatory),
      phoneNumber: formData.company.phoneNumber,
    },

    documents: documentArray,
    ...(assignedUser && { assignedUser }),
  };
};
